module.exports = __webpack_public_path__ + "static/img/m7.2ff1fe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/mobile/m7.png
// module id = ADcj
// module chunks = 12